export default {
      id: "command__sign_in_portal-usage",
      viewBox: "0 0 24 25",
      url: __webpack_public_path__ + "img/icons.svg#command__sign_in_portal",
      toString: function () {
        return this.url;
      }
    }